import React, { useContext, useEffect, useRef, useState } from 'react';
import { SERVER_URL } from '../../Services/ContectService';
import { Context } from '../../Context/Context';

const QuoteImage = ({ code, className, onClick, alt }) => {
    const { user } = useContext(Context);
    const [imgURL, setImgURL] = useState(null);
    const [condition, setCondition] = useState(false);

    const imageRef = useRef(null);

    const getImageURL = () => {
        fetch(`${SERVER_URL}/shop/service/${code}/get/image/`, {
            headers: {
                "Authorization": `Bearer ${user}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    return response.blob();
                }
                return false;
            })
            .then(blob => {
                if (!blob) {
                    setImgURL("");
                    return;
                }
                if (blob.type === "text/html") {
                    setImgURL("");
                } else {
                    const url = URL.createObjectURL(blob);
                    setImgURL(url);
                }
            })
            .catch(error => {
                setImgURL("");
            });
    }

    const setConditionHanlder = () => {
        const { top, bottom } = imageRef.current.getBoundingClientRect();
        if(bottom >= 0 && top <= window.innerHeight) {
            setCondition(true);
        }
    }

    useEffect(() => {
        if (imageRef && imageRef.current) {
            setConditionHanlder();
            document.addEventListener("scroll", setConditionHanlder);
        }

        return () => {
            document.removeEventListener("scroll", setConditionHanlder);
        }
    }, [imageRef]);

    useEffect(() => {
        if (condition && imgURL === null) {
            getImageURL();
        }
    }, [condition, imgURL]);

    return (
        <img
            ref={imageRef}
            src={imgURL || "/imgs/upload/wisercam image.png"}
            className={className || ""}
            alt={alt || "Service image"}
            onClick={onClick ? () => onClick() : () => { }}
        />
    );
}

export default QuoteImage;
